let showFn = null;
let confirmFn = null;
let sessionExpiredFn = null;
const nativeAlert = typeof window !== 'undefined' ? window.alert.bind(window) : null;
const nativeConfirm = typeof window !== 'undefined' ? window.confirm.bind(window) : null;

export const registerNotify = (fn) => {
  showFn = fn;
};

export const registerConfirm = (fn) => {
  confirmFn = fn;
};

export const registerSessionExpired = (fn) => {
  sessionExpiredFn = fn;
};

export const inferType = (message) => {
  const text = String(message || '');
  if (/✅|success|saved|created|updated|deleted|approved|correctamente/i.test(text)) return 'success';
  if (/❌|error|failed|denied|unable|mislukt/i.test(text)) return 'error';
  if (/⚠️|warning|sure|cannot be undone|sesión|session expired/i.test(text)) return 'warning';
  return 'info';
};

export const notify = (message, type) => {
  const resolved = type || inferType(message);
  if (showFn) {
    showFn(String(message ?? ''), resolved);
    return;
  }
  if (nativeAlert) nativeAlert(message);
};

// Pages often run several loaders at once, and when the backend is down
// they all fail together: one alert per burst, not one per loader.
// alert() blocks, so the window is counted again from when it is closed;
// otherwise the failures queued behind it would each open another one.
const LOAD_ERROR_WINDOW_MS = 3000;
let lastLoadErrorAt = -Infinity;

/**
 * Tell the user a list failed to load. `message` comes already translated.
 * 401 is skipped: api.js already sends the user to the login page.
 * 403 is skipped unless `main` is set: a side list this role can't see
 * shouldn't raise an alert on a page it can otherwise use.
 */
export const reportLoadError = (error, message, { main = false } = {}) => {
  const status = error?.response?.status;
  if (status === 401) return;
  if (status === 403 && !main) return;
  if (Date.now() - lastLoadErrorAt < LOAD_ERROR_WINDOW_MS) return;
  lastLoadErrorAt = Date.now();
  notify(message, 'error');
  lastLoadErrorAt = Date.now();
};

export const confirmDialog = (message) => {
  if (confirmFn) return confirmFn(String(message ?? ''));
  if (nativeConfirm) return Promise.resolve(nativeConfirm(message));
  return Promise.resolve(false);
};

export const triggerSessionExpired = () => {
  if (sessionExpiredFn) {
    sessionExpiredFn();
    return true;
  }
  return false;
};

export const getNativeAlert = () => nativeAlert;

export default notify;
